const programDetails = {
  bba: {
    title: "Bachelor of Business Administration (BBA)",
    department: "Department of Business Administration",
    schemaLink:
      "https://www.iba-suk.edu.pk/Content/pdf/offered-programs/Course%20Schema-First%20December%202020-BBA.pdf",
    sections: {
      overview: {
        heading: "Overview",
        content:
          "The Bachelor of Business Administration (BBA) program at the Department of Business Administration emphasizes a global perspective and community service through research-oriented knowledge. It aims to equip students with contemporary management skills, prepare them for managerial roles in both local and multinational organizations, and foster entrepreneurial initiatives. Additionally, the program facilitates pathways for further education, such as MBA, MS, and PhD programs at esteemed national and international institutions, while cultivating leadership, global sustainability, and ethical awareness in graduates.",
        points: [
          "Effective Communication Skills",
          "Creative and Analytical Problem-Solving Skills",
          "Critical and Reflective Thinking Abilities",
          "Leadership and Team Collaboration Skills",
          "Ethical Reasoning and Knowledge of Relevant Laws",
          "Proficiency in Technology and Digital Tools",
          "In-depth Understanding and Application of Core Business Concepts",
          "Integrative Skills with a Global Perspective",
          "Advanced Research Skills",
          "Entrepreneurial Mindset and Skills",
          "Awareness of Current Business Trends and Issues",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The BBA program is designed to provide students with a comprehensive understanding of fundamental business principles and practices. The curriculum encompasses core courses, electives, and a culminating project in the final year.",
        points: [
          "Duration: 4 years",
          "Number of Semesters: 8",
          "Total Credit Hours: 141",
          "Core Courses: 126 Credits",
          "Electives: 15 Credits",
          "HEC Requirement: 124-136 Credits",
        ],
      },
      admissionCriteria: {
        heading: "Eligibility Criteria",
        content:
          "To be considered for admission to the BBA program, candidates must meet the following requirements:",
        points: [
          "Completion of Intermediate/F.Sc with a minimum of 50% marks in the annual examination, with no supplemental exams or subject(s) condoned by the Board.",
          "A Level qualifications (with an average of 'C' grade in three principal subjects).",
          "American High School Diploma (with a minimum of 60%).",
          "International Baccalaureate (with at least 28 points out of 45).",
        ],
      },
      facultyInfo: {
        heading: "Faculty Information",
        content:
          "Detailed information regarding faculty members will be provided in a dedicated section.",
        points: [], // To be filled in later
      },
      events: {
        heading: "Upcoming Events",
        content:
          "Information about upcoming events will be presented in a dedicated section.",
        points: [], // To be filled in later
      },
    },
  },
  bba_agribusiness: {
    title: "Bachelor of Business Administration (Agribusiness)",
    department: "Joint Degree Program between UAF & Sukkur IBA University",
    schemaLink:
      "https://www.iba-suk.edu.pk/Content/pdf/offered-programs/BBA%20Agribusiness%20Courses%20Offered-Schema.pdf",
    sections: {
      overview: {
        heading: "Overview",
        content:
          "The Bachelor of Business Administration (Agribusiness) is a 4-year joint degree program offered by UAF and Sukkur IBA University, designed to serve the needs of the industry. This program caters to young individuals who have completed twelve years of education, regardless of their academic backgrounds, including humanities, science, arts, agribusiness, and commerce. The program emphasizes farm management and business principles, aiming to enhance personal development and provide graduates with the skills to pursue higher-paying jobs or start their own businesses.",
        points: [
          "Focus on farm management and business.",
          "Rigorous admission process for diverse educational backgrounds.",
          "Unique inter-provincial model program.",
          "Opportunities for personal development and higher salary jobs.",
          "Preparation for entrepreneurial ventures.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The BBA (Agribusiness) program is structured over 4 years, consisting of 8 regular semesters and a total of 132 credit hours, adhering to HEC requirements. The first 4 semesters will be conducted at UAF, followed by the next 4 semesters at Sukkur IBA University.",
        points: [
          "Duration: 4 years",
          "Number of Semesters: 8",
          "Total Credit Hours: 132",
          "Credit Hours at UAF: 68",
          "Credit Hours at Sukkur IBA University: 64",
          "HEC Requirement: 124-136 Credits",
        ],
      },
      admissionCriteria: {
        heading: "Eligibility Criteria",
        content:
          "To be considered for admission to the BBA (Agribusiness) program, candidates must meet the following requirements:",
        points: [
          "Completion of Intermediate/F.Sc with a minimum of 50% marks in the annual examination, with no supplemental exams.",
          "A Level qualifications (with an average of 'C' grade in three principal subjects).",
          "American High School Diploma (with a minimum of 60%).",
          "International Baccalaureate (with at least 28 points out of 45).",
        ],
      },
      facultyInfo: {
        heading: "Faculty Information",
        content:
          "Detailed information regarding faculty members will be provided in a dedicated section.",
        points: [], // To be filled in later
      },
      events: {
        heading: "Upcoming Events",
        content:
          "Information about upcoming events will be presented in a dedicated section.",
        points: [], // To be filled in later
      },
    },
  },

  bsa: {
    title: "Bachelor of Science in Accounting and Finance (BS A&F)",
    department: "Department of Business Administration",
    schemaLink:
      "https://www.iba-suk.edu.pk/Content/pdf/offered-programs/COURSES%20OFFERED-BSAF-Schema.pdf",
    sections: {
      overview: {
        heading: "Overview",
        content:
          "The Bachelor of Science in Accounting and Finance (BS A&F) program is designed to provide students with a challenging and career-oriented education that equips them with the necessary knowledge and skills for successful careers in business and accounting. The goal of the four-year program is to prepare students for professional studies and careers in auditing, corporate accounting, management, consulting, government, not-for-profit organizations, and taxation. The curriculum offers a blend of courses that facilitate the pursuit of professional qualifications such as CA, ACCA, ICMA, and CIMA.",
        points: [
          "Apply ethical reasoning in decision-making and understand laws and regulations of business and accounting.",
          "Present with oral proficiency and write effective business documents.",
          "Critically analyze business issues and apply quantitative tools to solve problems.",
          "Work effectively within teams.",
          "Develop innovative business solutions.",
          "Understand international issues.",
          "Understand and apply core business knowledge, International Financial Reporting Standards (IFRS), International Standards on Auditing (ISA), and Uniform Costing Practices.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The BS A&F program consists of 4 years of study across 8 semesters, culminating in a total of 126 credit hours, which includes 120 course credits and a 6-credit practicum.",
        points: [
          "Duration: 4 years",
          "Number of Semesters: 8",
          "Total Credit Hours: 126",
          "Course Credits: 120",
          "Practicum: 6 Credits",
          "HEC Requirement: 124-136 Credits",
        ],
      },
      admissionCriteria: {
        heading: "Eligibility Criteria",
        content:
          "Candidates must meet the following admission requirements to be considered for the BS Accounting and Finance program:",
        points: [
          "Intermediate/F.Sc with a minimum of 50% marks in the annual examination, with no supplementary exams.",
          "A Level qualifications (with at least an average of ‘C’ grade in three principal subjects).",
          "American High School Diploma (with a minimum of 60%).",
          "International Baccalaureate (with at least 28 points out of 45).",
          "Candidates must have completed H.S.C or equivalent with at least 50% marks at the time of appearing for the test and interview.",
        ],
      },
      facultyInfo: {
        heading: "Faculty Information",
        content:
          "Detailed information regarding faculty members will be provided in a dedicated section.",
        points: [], // To be filled in later
      },
      events: {
        heading: "Upcoming Events",
        content:
          "Information about upcoming events will be presented in a dedicated section.",
        points: [], // To be filled in later
      },
    },
  },
  bs_economics: {
    title: "Bachelor of Science in Economics (BS Economics)",
    department: "Department of Business Adminstration",
    schemaLink:
      "https://www.iba-suk.edu.pk/Content/pdf/offered-programs/Course-schema-BS-Economics.pdf",
    sections: {
      overview: {
        heading: "Overview",
        content:
          "The mission of the BS Economics program is to enhance the intellectual and professional competencies of our graduates by imparting knowledge through a meritorious culture that encourages critical thinking, active learning, ethical consciousness, and global awareness regarding economic issues. The program offers various specializations: Economics and Finance, focusing on applying economic theory to financial markets; Development Economics, which addresses economic challenges faced by developing countries; Environmental Economics, emphasizing the analysis of environmental problems; Public Planning and Policy, covering public policy and management; International Economics, providing insights into global trade and finance; Economics, Artificial Intelligence, and Data Analytics, exploring the intersection of AI and economics; and Behavioral Economics, which examines the psychological factors influencing economic decisions.",
        points: [
          "Apply ethical reasoning in decision-making.",
          "Present with oral proficiency and write effective economic and business documents.",
          "Critically analyze economic issues and apply problem-solving tools to various economic situations.",
          "Work effectively within teams.",
          "Design innovative economic solutions.",
          "Assess international economic issues related to both developed and developing countries.",
          "Apply economics discipline knowledge to address economic challenges.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The BS Economics program is a four-year degree program comprising eight regular semesters.",
        points: [
          "Duration: 4 years",
          "Number of Semesters: 8",
          "Total Credit Hours: 135",
          "Research Project: Equivalent to 3 courses (9 credit hours)",
          "Each course is equal to 3 credit hours, except Pakistan Studies and Islamic Studies or Comparative Religion, each of which is equal to 1.5 credit hours.",
        ],
      },
      admissionCriteria: {
        heading: "Eligibility Criteria",
        content:
          "To be considered for admission to the BS Economics program, candidates must meet the following requirements:",
        points: [
          "Completion of Intermediate/F.Sc with a minimum of 50% marks in the annual examination, with no supplemental exams.",
          "A Level qualifications (with an average of 'C' grade in three principal subjects).",
          "American High School Diploma (with a minimum of 60%).",
          "International Baccalaureate (with at least 28 points out of 45).",
        ],
      },
      facultyInfo: {
        heading: "Faculty Information",
        content:
          "Detailed information regarding faculty members will be provided in a dedicated section.",
        points: [], // To be filled in later
      },
      events: {
        heading: "Upcoming Events",
        content:
          "Information about upcoming events will be presented in a dedicated section.",
        points: [], // To be filled in later
      },
    },
  },

  bs_cs: {
    title: "Bachelor of Science in Computer Science (BSCS)",
    department: "Department of Computer Science",
    schemaLink:
      "https://www.iba-suk.edu.pk/Content/pdf/offered-programs/Annexure-A%20Schema%20of%20BS%20CS_Fall2020-Spring2024.pdf",
    sections: {
      overview: {
        heading: "Overview",
        content:
          "The mission of the Computer Science Department is to provide quality education in both theory and applications of computer science, information technology, and software engineering to serve the community. We aim to integrate with other departments for achieving knowledge as a whole. We strive to equip our graduates with awareness of ethical norms and technological skills to promote their entrepreneurial behavior and leadership expertise.",
        points: [
          "Adequate Domain Knowledge: Graduates will possess knowledge and skills for careers in applications development, database programming, systems analysis, and network management.",
          "Critical Analysis and Problem Solution: Graduates will analyze problems and develop optimized computer-based solutions.",
          "Multidisciplinary Approach: Graduates will work effectively in multidisciplinary teams and utilize relevant domain knowledge.",
          "Awareness of State-of-the-Art Technologies: Graduates will stay informed about technological advancements to make informed decisions.",
          "Effective Communication: Graduates will communicate ideas clearly in both oral and written forms.",
          "Ethical Values: Graduates will demonstrate professional and ethical standards.",
          "Society Services: Graduates will understand the societal impact of their technological work.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The BS Computer Science program is a four-year degree program comprising eight regular semesters.",
        points: [
          "Duration: 4 years",
          "Number of Semesters: 8",
          "Total Credit Hours: 141",
          "Core Courses: 126 Credits",
          "Electives: 15 Credits",
          "HEC Requirement: 124-136 Credits",
        ],
      },
      admissionCriteria: {
        heading: "Eligibility Criteria",
        content:
          "To be considered for admission to the BS Computer Science program, candidates must meet the following requirements:",
        points: [
          "Intermediate/F.Sc with a minimum of 50% marks in the annual examination, with no supplementary exams.",
          "A Level qualifications (with at least an average of 'C' grade in three principal subjects).",
          "American High School Diploma (with a minimum of 60%).",
          "International Baccalaureate (with at least 28 points out of 45).",
        ],
      },
      facultyInfo: {
        heading: "Faculty Information",
        content:
          "Detailed information regarding faculty members will be provided in a dedicated section.",
        points: [], // To be filled in later
      },
      events: {
        heading: "Upcoming Events",
        content:
          "Information about upcoming events will be presented in a dedicated section.",
        points: [], // To be filled in later
      },
    },
  },

  bs_se: {
    title: "Bachelor of Science in Software Engineering (BSSE)",
    department: "Department of Computer Science",
    schemaLink:
      "https://www.iba-suk.edu.pk/Content/pdf/offered-programs/Annexure-B%20Schema%20of%20BS%20SE_Fall2020-Spring2024.pdf",
    sections: {
      overview: {
        heading: "Overview",
        content:
          "The Bachelor of Science in Software Engineering program aims to produce graduates with adequate knowledge and skills to become competent software engineers, application developers, systems analysts, and database programmers. The curriculum emphasizes critical analysis, problem-solving, and awareness of the latest technologies in the field. Graduates will be equipped with the necessary tools and methods to model, simulate, and test software solutions effectively.",
        points: [
          "Adequate Domain Knowledge: Understanding of core software engineering principles, mathematics, and science.",
          "Critical Analysis and Problem Solution: Ability to analyze problems and develop optimized software solutions.",
          "Software Engineering Tools and Methods: Proficiency in using engineering tools and techniques for software development.",
          "Awareness of State-of-the-Art Technologies: Knowledge of current trends in computing and software development.",
          "Effective Communication: Skills to communicate ideas effectively in both oral and written formats.",
          "Ethical Values: Understanding of professional and ethical standards in technology.",
          "Society Services: Awareness of the impact of technology on society and the environment.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The BS Software Engineering program is a four-year degree program comprising eight regular semesters.",
        points: [
          "Duration: 4 years",
          "Number of Semesters: 8",
          "Total Credit Hours: 141",
          "Core Courses: 126 Credits",
          "Electives: 15 Credits",
          "HEC Requirement: 124-136 Credits",
        ],
      },
      admissionCriteria: {
        heading: "Eligibility Criteria",
        content:
          "To be considered for admission to the BS Software Engineering program, candidates must meet the following requirements:",
        points: [
          "Completion of Intermediate/F.Sc with a minimum of 50% marks in the annual examination, with no supplementary exams.",
          "A Level qualifications (with an average of 'C' grade in three principal subjects).",
          "American High School Diploma (with a minimum of 60%).",
          "International Baccalaureate (with at least 28 points out of 45).",
        ],
      },
      facultyInfo: {
        heading: "Faculty Information",
        content:
          "Detailed information regarding faculty members will be provided in a dedicated section.",
        points: [], // To be filled in later
      },
      events: {
        heading: "Upcoming Events",
        content:
          "Information about upcoming events will be presented in a dedicated section.",
        points: [], // To be filled in later
      },
    },
  },

  bs_ai: {
    title: "Bachelor of Science in Artificial Intelligence (BS AI)",
    department: "Department of Computer Science",
    schemaLink:
      "https://www.iba-suk.edu.pk/Content/pdf/Annexure-C%20Schema%20of%20BS%20AI.pdf",
    sections: {
      overview: {
        heading: "Overview",
        content:
          "The objective of the Bachelor’s degree in Artificial Intelligence program is to produce well-rounded graduates, having a strong foundation in theoretical concepts and skills to design and implement complex intelligent software using multiple programming technologies under different operating systems and backend technologies. Graduates will be prepared for careers in the local and international IT industry, equipped with effective communication skills and a commitment to continuous education.",
        points: [
          "Academic Education: Prepare graduates as AI professionals.",
          "Knowledge for Solving Computing Problems: Apply knowledge of AI and relevant disciplines to solve defined problems.",
          "Problem Analysis: Identify, formulate, and solve complex AI-related problems using fundamental principles.",
          "Design/Development of Solutions: Design and evaluate solutions for complex AI problems considering public health, safety, and societal implications.",
          "Modern Tool Usage: Create and apply appropriate techniques and modern computing tools to AI activities.",
          "Individual and Team Work: Function effectively as individuals and in diverse teams.",
          "Communication: Communicate effectively about complex computing activities.",
          "AI Professionalism and Society: Understand societal issues within local and global contexts relevant to AI practice.",
          "Ethics: Commit to professional ethics and responsibilities.",
          "Life-long Learning: Engage in independent learning for continual development as an AI professional.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The BS in Artificial Intelligence program is a four-year degree program comprising eight regular semesters.",
        points: [
          "Duration: 4 years",
          "Number of Semesters: 8",
          "Total Credit Hours: 130",
          "Core Courses: 46 Credits",
          "Domain Core: 18 Credits",
          "Domain Electives: 21 Credits",
          "Mathematics & Supporting Courses: 12 Credits",
          "Elective Supporting Courses: 3 Credits",
          "General Education Requirements: 30 Credits",
        ],
      },
      admissionCriteria: {
        heading: "Eligibility Criteria",
        content:
          "To be considered for admission to the BS in Artificial Intelligence program, candidates must meet the following requirements:",
        points: [
          "At least 50% marks in Intermediate (HSSC) examination with Mathematics or equivalent qualification certified by IBCC.",
          "Students with Pre-Medical must pass deficiency courses of Mathematics (6 credit hours) in the first two semesters.",
        ],
      },
      facultyInfo: {
        heading: "Faculty Information",
        content:
          "Detailed information regarding faculty members will be provided in a dedicated section.",
        points: [], // To be filled in later
      },
      events: {
        heading: "Upcoming Events",
        content:
          "Information about upcoming events will be presented in a dedicated section.",
        points: [], // To be filled in later
      },
    },
  },
  bs_mathematics: {
    title: "Bachelor of Science in Mathematics (BS Mathematics)",
    department: "Department of Mathematics",
    schemaLink:
      "https://iba-suk.edu.pk/Content/xlsx/fall2021/Courses%20Offered%20(Fall%202021)%20Math%20Department%20MOE-class-numbers.xlsx",
    sections: {
      overview: {
        heading: "Overview",
        content:
          "The BS Mathematics program aims to address the limited access to quality education in Mathematics and the increasing unemployment rate, which contribute to socio-economic challenges in the country. By utilizing modern mathematical techniques tailored to market and industrial needs, this program aspires to produce graduates who will bring positive change to society.",
        points: [
          "Develop quantitative skills among students.",
          "Enhance knowledge for higher levels of independent learning.",
          "Utilize Mathematics as a tool in various fields of Industrial and Applied Sciences.",
          "Provide quality education with modern scientific tools for a global outlook.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The BS Mathematics program is a four-year degree program comprising eight regular semesters.",
        points: [
          "Duration: 4 years",
          "Number of Semesters: 8",
          "Total Credit Hours: 141",
          "Core Courses: 126 Credits",
          "Electives: 15 Credits",
          "HEC Requirement: 124-136 Credits",
        ],
      },
      admissionCriteria: {
        heading: "Eligibility Criteria",
        content:
          "To be considered for admission to the BS Mathematics program, candidates must meet the following requirements:",
        points: [
          "Completion of Intermediate/F.Sc with a minimum of 50% marks in the annual examination, with no supplementary exams.",
          "A Level qualifications (with an average of 'C' grade in three principal subjects).",
          "American High School Diploma (with a minimum of 60%).",
          "International Baccalaureate (with at least 28 points out of 45).",
        ],
      },
      facultyInfo: {
        heading: "Faculty Information",
        content:
          "Detailed information regarding faculty members will be provided in a dedicated section.",
        points: [], // To be filled in later
      },
      events: {
        heading: "Upcoming Events",
        content:
          "Information about upcoming events will be presented in a dedicated section.",
        points: [], // To be filled in later
      },
    },
  },
  bs_physical_education: {
    title: "Bachelor of Science in Physical Education and Sports Sciences (BS)",
    department: "Physical Education & Sports Sciences Department",
    schemaLink:
      "https://www.iba-suk.edu.pk/Content/pdf/Course%20Scheme%20BS%20and%20AD%20Physical.pdf",
    sections: {
      overview: {
        heading: "Overview",
        content:
          "The BS Physical Education & Sports Sciences program was established by Vice Chancellor (Late) Professor Nisar Ahmed Siddiqui in 2018 to provide students with the academic foundation to assist individuals in achieving health and fitness goals. The program aims to produce graduates capable of addressing challenges in the field of Physical Education and Sports Sciences. The department aims to take an active leadership role in developing health and physical activity across all levels, through the application of Physical Education and Sports Sciences theories and practices. The mission of the program is to critically engage students with a broad spectrum of perspectives in the field, drawing on a range of research and applied methodologies.",
        points: [
          "Produce graduates capable of addressing challenges in Physical Education and Sports Sciences.",
          "Take an active leadership role in developing health and physical activity across all levels.",
          "Apply Physical Education and Sports Sciences theories and practices effectively.",
          "Critically engage students with diverse perspectives in the field.",
          "Prepare graduates to improve overall health in society.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The BS Physical Education & Sports Sciences program is a four-year degree program comprising eight regular semesters.",
        points: [
          "Duration: 4 years",
          "Number of Semesters: 8",
          "Total Credit Hours: 141",
          "Core Courses: 126 Credits",
          "Electives: 15 Credits",
          "HEC Requirement: 124-136 Credits",
        ],
      },
      admissionCriteria: {
        heading: "Eligibility Criteria",
        content:
          "To be considered for admission to the BS Physical Education and Sports Sciences program, candidates must meet the following requirements:",
        points: [
          "Completion of 12 years of education (FA/FSc, Pre-Engineering, Pre-Medical, Computer Science, Commerce, or equivalent fields) with a minimum of 50% marks.",
          "A Level or equivalent qualifications with at least 'C' grade.",
        ],
      },
      facultyInfo: {
        heading: "Faculty Information",
        content:
          "Detailed information regarding faculty members will be provided in a dedicated section.",
        points: [], // To be filled in later
      },
      events: {
        heading: "Upcoming Events",
        content:
          "Information about upcoming events will be presented in a dedicated section.",
        points: [], // To be filled in later
      },
    },
  },

  associate_degree: {
    title: "Associate Degree in Physical Education and Sports Sciences (AD)",
    department: "Physical Education Department",
    schemaLink:
      "https://www.iba-suk.edu.pk/Content/pdf/Course%20Scheme%20BS%20and%20AD%20Physical.pdf",
    sections: {
      overview: {
        heading: "Overview",
        content:
          "The Associate Degree in Physical Education and Sports Sciences program offers a two-year course designed to provide students with foundational knowledge and practical skills in physical education, sports sciences, and fitness. The program equips students with the tools to assist individuals in achieving their health and fitness goals and introduces a broad background in the theoretical and practical aspects of sports sciences.",
        points: [
          "Provide foundational knowledge in physical education and sports sciences.",
          "Equip students with practical skills to promote health and fitness.",
          "Prepare students for entry-level roles in physical education and sports fields.",
          "Focus on both theoretical understanding and practical application.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The Associate Degree in Physical Education and Sports Sciences is a two-year program, divided into four semesters.",
        points: [
          "Duration: 2 years",
          "Number of Semesters: 4",
          "Total Credit Hours: 60",
          "Core Courses: 48 Credits",
          "Electives: 12 Credits",
        ],
      },
      admissionCriteria: {
        heading: "Eligibility Criteria",
        content:
          "To be considered for admission to the Associate Degree in Physical Education and Sports Sciences, candidates must meet the following requirements:",
        points: [
          "Completion of 12 years of education (FA/FSc, Pre-Engineering, Pre-Medical, Computer Science, Commerce, or equivalent fields) with a minimum of 50% marks.",
          "A Level or equivalent qualifications with at least 'C' grade.",
        ],
      },
      facultyInfo: {
        heading: "Faculty Information",
        content:
          "Detailed information regarding faculty members will be provided in a dedicated section.",
        points: [], // To be filled in later
      },
      events: {
        heading: "Upcoming Events",
        content:
          "Information about upcoming events will be presented in a dedicated section.",
        points: [], // To be filled in later
      },
    },
  },
  be: {
    title: "Bachelor of Engineering in Electrical Engineering (BE)",
    department: "Department of Electrical Engineering",
    schemaLink: "https://ee.iba-suk.edu.pk/schema.html",
    sections: {
      overview: {
        heading: "Overview",
        content:
          "The Bachelor of Engineering in Electrical Engineering program at Sukkur IBA University is designed to produce highly skilled engineers with a strong foundation in technical knowledge, ethical values, and innovative thinking. Established with the mission to address societal challenges, the program emphasizes both theoretical learning and practical application across key areas of electrical engineering. Graduates are equipped to contribute to advancements in Telecommunication, Electronics, Computer Systems, and Power Engineering, while fostering leadership, entrepreneurship, and research excellence.",
        points: [
          "Develop a strong foundation in core engineering disciplines, including Telecommunication, Electronics, Computer Systems, and Power Engineering.",
          "Enhance problem-solving, communication, and leadership skills to meet industry and societal needs.",
          "Prepare graduates for careers in both corporate sectors and entrepreneurial ventures.",
          "Promote awareness of contemporary issues, including the social, ethical, and environmental impact of technology.",
          "Foster research capabilities and practical engineering skills for real-world problem-solving.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The BE Electrical Engineering program is a comprehensive four-year degree spanning eight semesters. The curriculum combines rigorous theoretical education with hands-on practical experience, preparing students for both industry and research roles.",
        points: [
          "Duration: 4 years",
          "Number of Semesters: 8",
          "Core Courses: Telecommunication, Electronics, Power Systems, Computer Systems, and Control Engineering.",
          "Capstone Project: A final-year project focused on solving real-world engineering problems.",
          "Credit Hours: As per HEC requirements, including core and elective courses.",
        ],
      },
      admissionCriteria: {
        heading: "Eligibility Criteria",
        content:
          "To be eligible for admission to the BE Electrical Engineering program, applicants must meet the following requirements:",
        points: [
          "Completion of 12 years of education (FSc Pre-Engineering or equivalent) with at least 60% marks.",
          "A Level or equivalent qualifications with a minimum 'C' grade in principal subjects.",
          "Successful performance in Sukkur IBA University's entrance examination.",
        ],
      },
      facultyInfo: {
        heading: "Faculty Information",
        content:
          "The Department of Electrical Engineering boasts a highly qualified faculty with expertise in diverse fields such as Telecommunication, Power Systems, Electronics, and Control Engineering. Detailed information about faculty members, their research interests, and academic contributions will be provided.",
        points: [], // To be filled in later
      },
      events: {
        heading: "Upcoming Events",
        content:
          "The department regularly organizes workshops, seminars, and collaborative industry events to enhance learning and foster industry-academia interaction. Information about upcoming events will be provided.",
        points: [], // To be filled in later
      },
    },
  },

  be_cse: {
    title: "Bachelor of Engineering in Computer Systems Engineering (BE-CSE)",
    department: "Department of Computer Systems Engineering (CSE)",
    schemaLink: "https://www.iba-suk.edu.pk/Content/pdf/CSE-Course-schema.pdf",
    sections: {
      overview: {
        heading: "Overview",
        content:
          "The Department of Computer Systems Engineering at Sukkur IBA University focuses on equipping students with modern engineering techniques to solve real-world problems through the development of both hardware and software systems. This program trains students to design and build smart products that integrate computers into larger operations. With state-of-the-art laboratories and highly qualified faculty, the department offers a four-year Bachelor of Engineering (BE) degree in Computer Systems Engineering, preparing graduates to contribute meaningfully in a technologically driven world.",
        points: [
          "Focuses on developing both software and hardware skills for smart product design.",
          "Provides modern engineering education with state-of-the-art facilities and qualified faculty.",
          "Prepares graduates to address societal and environmental challenges using technological advancements.",
          "Promotes ethical and sustainable engineering practices.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The BE Computer Systems Engineering program is a four-year degree, spanning eight semesters. The program combines a rigorous theoretical foundation with practical applications in various engineering domains.",
        points: [
          "Duration: 4 years",
          "Number of Semesters: 8",
          "Core Courses: Software Engineering, Embedded Systems, Digital Signal Processing, Computer Architecture.",
          "Capstone Project: A final-year project focused on developing real-world solutions.",
          "Credit Hours: As per HEC and PEC requirements.",
        ],
      },
      admissionCriteria: {
        heading: "Eligibility Criteria",
        content:
          "Applicants to the BE Computer Systems Engineering program must meet the following requirements:",
        points: [
          "Completion of F.Sc Pre-Engineering or ICS with a minimum of 60% marks in the annual examination.",
          "No condoned subjects in board exams.",
          "Qualify Sukkur IBA's entrance test, followed by a group discussion and interview.",
          "Applicants must have completed HSC or equivalent at the time of the interview.",
          "Provisional admission is subject to meeting the minimum requirements post-final exam results.",
        ],
      },
      facultyInfo: {
        heading: "Faculty Information",
        content:
          "The Department of Computer Systems Engineering has a diverse team of faculty members specializing in areas such as Embedded Systems, Software Engineering, and Computer Architecture. Detailed information about their qualifications and research areas will be provided.",
        points: [], // To be filled in later
      },
      events: {
        heading: "Upcoming Events",
        content:
          "The department organizes various technical workshops, seminars, and industry collaborations to enhance student learning and promote industry-academia interaction. Upcoming event information will be provided in due course.",
        points: [], // To be filled in later
      },
    },
  },

  bed_hons: {
    title: "Bachelor of Education (B.Ed Hons) - Secondary (4 Years)",
    department: "Department of Education",
    schemaLink:
      "https://www.iba-suk.edu.pk/Content/pdf/offered-programs/B.Ed%20(Hons)%20-%204%20YEARS%20-%20FOR%20WEBSITE.pdf",
    sections: {
      overview: {
        heading: "Overview",
        content:
          "The B.Ed (Hons) Secondary program is designed to develop educational leaders, practitioners, and reformers equipped with a strong foundation in educational theory, research, and global trends. It prepares graduates to become effective educators with a global outlook, innovative skills, and ethical values to lead educational systems and influence change in society. This four-year degree program emphasizes the development of leadership and management skills along with the ability to engage in and disseminate research for the future of education.",
        points: [
          "Develop future educational leaders with strong theoretical and practical knowledge.",
          "Foster critical and reflective thinking for educational challenges.",
          "Prepare graduates to undertake and contribute to educational research.",
          "Global perspective on educational theories, trends, and issues.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The B.Ed (Hons) Secondary program is a four-year degree divided into eight semesters, focusing on developing theoretical foundations and practical teaching skills for secondary education.",
        points: [
          "Duration: 4 Years (8 Semesters)",
          "Semester Duration: 16-18 weeks",
          "Number of Semesters: 8",
          "Course Load per Semester: 15-18 Credit Hours",
          "Number of Courses per Semester: 4-6",
          "Includes practical teaching sessions in real-world classroom environments.",
        ],
      },
      admissionCriteria: {
        heading: "Eligibility Criteria",
        content:
          "Applicants to the B.Ed (Hons) Secondary program must meet the following requirements:",
        points: [
          "Higher Secondary Certificate (F.A/F.Sc) with a minimum of 50% marks.",
          "Successful completion of the Sukkur IBA University's admission test.",
        ],
      },
      facultyInfo: {
        heading: "Faculty Information",
        content:
          "The Department of Education boasts highly qualified faculty members specializing in educational leadership, pedagogy, and curriculum development. Detailed faculty information is available on the department's website.",
        points: [], // To be filled later
      },
      events: {
        heading: "Upcoming Events",
        content:
          "The department organizes various workshops, seminars, and research conferences. Upcoming event details will be updated on the department's portal.",
        points: [], // To be filled later
      },
    },
  },
  bed_extension: {
    title: "Bachelor of Education (B.Ed) Extension - 2.5 Years",
    department: "Department of Education",
    schemaLink:
      "https://www.iba-suk.edu.pk/Content/pdf/B.Ed%202.5%20(Extension)%20degree%20program%20-Revised.pdf",
    sections: {
      overview: {
        heading: "Overview",
        content:
          "The B.Ed Extension program is a 2.5-year degree designed for individuals who have already completed 14 years of education and wish to extend their qualification in the field of education. This program builds on prior knowledge to develop critical and reflective thinking, evaluative skills, and research capabilities. It aims to produce professionals capable of addressing contemporary educational challenges and advancing in their careers as leaders and innovators in education.",
        points: [
          "Designed for individuals with 14 years of education looking to extend their qualifications.",
          "Focus on developing research, evaluative thinking, and leadership skills in education.",
          "Prepares graduates for leadership roles in educational systems and institutions.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The B.Ed Extension program is a 2.5-year degree divided into five semesters, focusing on advanced educational theories, research methodologies, and practical skills to enhance teaching and leadership in education.",
        points: [
          "Duration: 2.5 Years (5 Semesters)",
          "Semester Duration: 16-18 weeks",
          "Number of Semesters: 5",
          "Course Load per Semester: 15-18 Credit Hours",
          "Number of Courses per Semester: 6",
          "Advanced coursework in educational theory, leadership, and research.",
          "Preparation for higher-level educational leadership roles.",
        ],
      },
      admissionCriteria: {
        heading: "Eligibility Criteria",
        content:
          "Applicants to the B.Ed Extension 2.5-year program must meet the following requirements:",
        points: [
          "Bachelor's degree (B.A, B.Sc, B.Com) or 14 years of education in any HEC-recognized discipline.",
          "Associate Degree or equivalent qualification with a minimum of 50% marks.",
          "Successful completion of the Sukkur IBA University's admission test.",
        ],
      },
      facultyInfo: {
        heading: "Faculty Information",
        content:
          "The faculty in the B.Ed Extension program are experts in educational research, policy planning, and teaching methodologies. Faculty members are dedicated to helping students develop into future educational leaders.",
        points: [], // To be filled later
      },
      events: {
        heading: "Upcoming Events",
        content:
          "Workshops, seminars, and research activities are regularly organized to enrich the learning experience. Details of upcoming events will be provided on the university’s website.",
        points: [], // To be filled later
      },
    },
  },
  bs_media_communications: {
    title: "Bachelor of Science in Media and Communications (BS-MC)",
    department: "Department of Media and Communications",
    schemaLink:
      "https://www.iba-suk.edu.pk/Content/pdf/Course%20Scheme%20BS%20Media.pdf",
    sections: {
      overview: {
        heading: "Program Overview",
        content:
          "The Bachelor of Science in Media and Communications (BS-MC) program is designed to prepare students for dynamic careers in the fast-evolving media landscape. It seeks to foster innovation, ethical practices, and effective communication in an era marked by technological and social transformation. By integrating theoretical knowledge with hands-on experience, the program equips students with the skills to excel in various media industries such as journalism, public relations, digital media, and communications. The program emphasizes the development of ethical and socially responsible media professionals who can contribute to sustainable and successful societies.",
        points: [
          "Comprehensive focus on developing key skills in communication, media production, and creative industries.",
          "Prepares graduates for diverse careers in journalism, media, public relations, digital marketing, and corporate communications.",
          "Incorporates ethical media practices, global awareness, and the ability to navigate the digital media landscape.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The BS Media and Communications program is structured as a four-year undergraduate degree that provides a balanced curriculum, blending core and elective courses across multiple media platforms. The program is designed to develop students' competencies in both traditional and digital media, enabling them to respond to the changing demands of the industry.",
        points: [
          "Duration: 4 Years",
          "Number of Semesters: 8",
          "Total Credit Hours: 133",
          "Core Courses: 121 Credits",
          "Electives: 12 Credits",
          "HEC Requirements: 124-136 Credits",
        ],
      },
      admissionCriteria: {
        heading: "Eligibility Criteria",
        content:
          "Applicants must meet the following eligibility requirements to be considered for admission to the BS Media and Communications program:",
        points: [
          "Intermediate / F.Sc with a minimum of 50% marks in the annual examination, with no condoned subjects.",
          "A-level with at least an average grade in three principal subjects.",
          "American High School Diploma with a minimum GPA of 60%.",
          "International Baccalaureate (IB) with at least 28 points out of 45.",
        ],
      },
      facultyInfo: {
        heading: "Faculty Information",
        content:
          "The Department of Media and Communications is supported by a team of highly qualified faculty members who bring extensive academic expertise and industry experience in media studies, journalism, digital content creation, and strategic communication. Faculty members are committed to providing an engaging and transformative learning environment through innovative teaching methodologies, practical exposure, and research opportunities.",
        points: [], // Faculty details can be filled later as needed
      },
      events: {
        heading: "Upcoming Events",
        content:
          "The department hosts a range of events, including workshops, guest lectures, media projects, and seminars that aim to provide students with hands-on experience and industry insights. These events offer valuable opportunities for networking, skill development, and exposure to real-world media practices. Upcoming event details will be shared on the university's official platforms.",
        points: [], // Event details can be added when available
      },
    },
  },
  mphil_education: {
    title: "M.Phil. in Education",
    department: "Department of Education",
    schemaLink:
      "https://www.iba-suk.edu.pk/Content/pdf/offered-programs/Course%20Scheme_MPhil%20in%20Education.pdf",
    sections: {
      overview: {
        heading: "Program Overview",
        content:
          "The M.Phil. in Education program aims to cultivate educational leaders, policy planners, practitioners, implementers, and reformers. It provides participants with a robust theoretical and practical foundation in educational principles, preparing them for doctoral studies in education.",
        points: [
          "Fosters innovative skills and ethical values tailored to educational contexts.",
          "Prepares leaders with a global perspective on education.",
          "Emphasizes the design and transformation of educational systems.",
          "Encourages both theoretical and applied research engagement.",
          "Offers discipline-specific knowledge on key educational theories.",
          "Promotes evaluative thinking by analyzing contemporary views and policies.",
          "Encourages critical and reflective thinking through engagement in current debates.",
          "Enhances research skills in proposal development and applied research execution.",
          "Cultivates a global outlook with ethical engagement across diverse cultures.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "This program is structured to facilitate a comprehensive understanding and critical analysis of educational theories and practices, empowering students to conduct meaningful research.",
        points: [
          "Duration: 2 years",
          "Total Credit Hours: Varies based on curriculum requirements",
          "Core Courses: Detailed in the course scheme",
          "Thesis: 6 credits",
        ],
      },
      eligibilityCriteria: {
        heading: "Eligibility Criteria",
        content:
          "Applicants must possess 16 years of education in any discipline with at least 50% marks, along with a B.Ed or M.Ed degree with a minimum of 60% marks or a 2.2 CGPA from any HEC-recognized university. Candidates must also have cleared the GAT-General with at least 50% marks or the SIBA Graduate Test-General.",
        points: [
          "16 years of education with a minimum of 50% marks.",
          "B.Ed/M.Ed with at least 60% marks or a 2.2 CGPA.",
          "Successful completion of GAT-General or SIBA Graduate Test-General.",
        ],
      },
      admissionProcess: {
        heading: "Admission Process",
        content:
          "The admission process includes an entrance test and an interview conducted by the admissions committee.",
        points: [
          "Sukkur IBA University Entry Test (NTS GAT is also accepted) with a minimum qualifying score of 50%.",
          "Successful completion of the interview with the admissions committee.",
          "Final selection based on the following weightages: Entrance Test (60%), Interview (40%).",
        ],
      },
      facultyInfo: {
        heading: "Faculty Information",
        content:
          "The program is supported by a distinguished faculty with extensive expertise in educational theory and practice, committed to providing an engaging learning environment and mentorship.",
        points: [], // Faculty details can be added later as needed
      },
      additionalRequirements: {
        heading: "Additional Requirements",
        content:
          "Certain candidates may be required to complete deficiency courses. The program mandates a thesis requirement, demonstrating students' proficiency in scientific thinking, research methodologies, and effective communication of research findings.",
        points: [
          "Completion of up to 6 deficiency courses totaling 18 credits.",
          "Thesis writing as part of major studies, worth 6 credits, focusing on scientific thinking, mastery of research methods, and effective communication of research outcomes.",
          "A minimum GPA of 2.2 or 60% in annual examinations.",
        ],
      },
    },
  },
  mba: {
    title: "MBA (2-Year Case Based Program)",
    department: "Department of Business Administration",
    schemaLink: "https://www.iba-suk.edu.pk/Content/pdf/MBA_Course_Scheme.pdf", // Replace with actual link if available
    sections: {
      overview: {
        heading: "Program Overview",
        content:
          "The MBA (2-Year Case Based Program) is designed to equip students with modern knowledge and skills required to lead, restructure, and contribute to organizations in both local and multinational contexts. It aims to foster entrepreneurial ventures, particularly at a large scale.",
        points: [
          "Develops strategic leaders with a global perspective.",
          "Prepares graduates for managerial roles in various industries.",
          "Emphasizes case-based learning and real-world applications.",
          "Encourages innovation and entrepreneurial thinking.",
          "Focuses on ethical leadership and corporate responsibility.",
          "Enhances problem-solving and decision-making skills.",
          "Fosters strong communication and negotiation abilities.",
          "Promotes teamwork and collaboration among diverse groups.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The MBA program consists of a comprehensive curriculum designed to provide a holistic understanding of business management, blending theoretical concepts with practical applications.",
        points: [
          "Duration: 2 Years",
          "Semesters: 4 Semesters",
          "Total Credit Hours: 60",
          "Core Courses: 36 Credits",
          "Electives: 9 Credits",
          "Project (6 months): 12 Credits",
          "HEC Requirement: 60-72 Credit Hours (with potential exemptions for 4-year Business Graduates)",
        ],
      },
      eligibilityCriteria: {
        heading: "Eligibility Criteria",
        content:
          "Applicants must have 16 years of education from an HEC-recognized university/institute with a minimum of 60% marks or a 2.2 GPA.",
        points: [
          "16 years of education in a business discipline.",
          "Minimum of 60% marks or a 2.2 GPA.",
          "Candidates must have cleared GAT-General Test with at least 50% marks or should appear in the SIBA-GAT General Test.",
        ],
      },
      admissionProcess: {
        heading: "Admission Process",
        content:
          "The admission process includes a comprehensive examination and an interview conducted by the admission committee.",
        points: [
          "Completed application form and supporting documents submitted by the deadline.",
          "Entry Test (minimum qualifying score of 50%).",
          "Performance in the Admission Interview.",
          "Work experience is strongly preferred, though not mandatory.",
          "Final selection based on Entrance Test (60%) and Interview (40%).",
        ],
      },
      facultyInfo: {
        heading: "Faculty Information",
        content:
          "The program is delivered by a team of experienced faculty members with extensive knowledge in various fields of business management, committed to providing mentorship and a supportive learning environment.",
        points: [], // Faculty details can be added later as needed
      },
      additionalRequirements: {
        heading: "Additional Requirements",
        content:
          "Candidates may be required to complete a comprehensive examination prior to the award of the degree, ensuring they have met all program requirements.",
        points: ["Comprehensive Examination for the award of the degree."],
      },
    },
  },

  ms_management_science: {
    title: "MS in Management Sciences",
    department: "Department of Management Sciences",
    schemaLink:
      "https://www.iba-suk.edu.pk/offered-programs/ms-managment-science",
    sections: {
      overview: {
        heading: "Program Overview",
        content:
          "The MS in Management Sciences program prepares students to explore and analyze contemporary management concepts and theories, contributing to the field through rigorous research and practical applications. It emphasizes ethical considerations and community values in business management.",
        points: [
          "Equips students with advanced analytical and research skills.",
          "Prepares graduates for leadership roles in various industries.",
          "Emphasizes collaboration and interdisciplinary approaches.",
          "Focuses on ethical considerations and community values in business.",
          "Encourages effective communication and presentation skills.",
          "Develops problem-solving abilities in complex business scenarios.",
        ],
      },
      programGoals: {
        heading: "Program Goals",
        content: "Our students should be able to:",
        points: [
          "Explore and analyze contemporary management concepts and theories in areas of particular interest.",
          "Identify major streams of research in their area of interest and contribute effectively.",
          "Demonstrate problem-solving and technical skills related to business management.",
          "Utilize the latest computer technologies and software relevant to their research.",
          "Work collaboratively in interdisciplinary contexts.",
          "Communicate effectively through written and oral means.",
          "Examine personal and community values alongside ethical dimensions of business management.",
        ],
      },
      programObjectives: {
        heading: "Program Objectives",
        content: "The program aims to achieve the following objectives:",
        points: [
          "Students will be compatible with current market requirements.",
          "Students will develop insights into core business management concepts and provide solutions to contemporary business problems in local and international organizations.",
          "Graduates will possess analytical skills to identify emerging research opportunities, alongside quantitative and qualitative research skills.",
          "Students will generate multiple solutions and select optimized solutions while excelling in challenging environments.",
          "Students will synchronize their research with related disciplines and conduct interdisciplinary research.",
          "Students will produce well-written research work and present & defend their findings.",
          "Students will align their personal values with community values, conducting research in accordance with socio-cultural norms.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The MS in Management Sciences program is structured to provide a comprehensive understanding of management principles, preparing students for both academic and professional careers.",
        points: [
          "Duration: Minimum 2 years & Maximum 4 years",
          "Semesters: 4 Semesters",
          "Total Credit Hours: 30",
          "Core Courses: 18 Credits",
          "Elective Courses: 6 Credits",
          "Thesis: 6 Credits (MS Thesis)",
          "Specializations: Human Resource Management, Marketing, Finance",
        ],
      },
      eligibilityCriteria: {
        heading: "Eligibility Criteria",
        content:
          "Candidates must meet the following eligibility requirements for admission:",
        points: [
          "BBA (4 years) program with 124–136 Credit Hours and a minimum CGPA of 2.2.",
          "16 years of education in related fields with first division from an HEC-recognized university/institution.",
          "Candidates must have passed the NTS test before applying for admission.",
          "Candidates must appear in the Sukkur IBA Admission test for MS/M.Phil., which includes:",
          "- 50% from related subjects",
          "- 25% from English",
          "- 25% from Mathematics.",
        ],
      },
      admissionProcess: {
        heading: "Admission Process",
        content:
          "The admission process includes a test composed of multiple components relevant to the field of management, assessing candidates' readiness for the program.",
        points: [
          "Entry Test composed of: 50% from relevant field subjects, 25% from English, and 25% from Mathematics.",
        ],
      },
      facultyInfo: {
        heading: "Faculty Information",
        content:
          "The program features a diverse faculty with expertise in various domains of management, dedicated to fostering an engaging and supportive learning environment.",
        points: [], // Faculty details can be added later as needed
      },
      additionalRequirements: {
        heading: "Additional Requirements",
        content:
          "Candidates must fulfill specific degree requirements, including thesis submission and defense, along with successful completion of the NTS GAT (General) test.",
        points: [
          "Minimum 2.2 CGPA for graduation.",
          "Thesis submission and defense approved by internal and external examiners.",
          "Completion of NTS GAT (General) test.",
        ],
      },
    },
  },
  ms_mathematics: {
    title: "MS in Mathematics",
    department: "Department of Mathematics",
    schemaLink:
      "https://www.iba-suk.edu.pk/Content/pdf/Books/MS%20Program%20Maths.pdf", // Actual link if available
    sections: {
      overview: {
        heading: "Program Overview",
        content:
          "The MS in Mathematics program at Sukkur IBA University is designed to prepare students for careers in research, applied mathematics, and academia. The program offers students an in-depth understanding of specialized fields such as Mathematical Finance, Abstract Algebra, Fluid Mechanics, and Computational Mathematics. The program emphasizes both theoretical knowledge and practical applications, equipping students with the skills needed to solve complex mathematical problems and conduct cutting-edge research.",
        points: [
          "Develop excellence in Mathematical research and lay a foundation for PhD studies.",
          "Enhance students' quantitative literacy and analytical thinking.",
          "Equip students with advanced skills in specialized fields of Mathematics.",
          "Enable the use of technology, software, and computational tools for research and problem-solving.",
          "Prepare students to effectively disseminate Mathematical knowledge through writing and oral presentations.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The MS Mathematics program is structured to offer a solid foundation in core mathematical areas while allowing students to specialize in fields of their interest. The program includes a blend of coursework and a research thesis, promoting both theoretical and applied learning.",
        points: [
          "Duration: Minimum 2 years, Maximum 4 years",
          "Semesters: 4 Semesters",
          "Total Credit Hours: 30",
          "Core Courses: 18 Credits",
          "Elective Courses: 6 Credits",
          "Thesis: 6 Credits",
        ],
      },
      eligibilityCriteria: {
        heading: "Eligibility Criteria",
        content:
          "Applicants must meet the following criteria to be eligible for the MS Mathematics program:",
        points: [
          "A 16-year education with a relevant Bachelor's degree from an HEC-recognized institution.",
          "Candidates must have passed the GAT (General) or STS test with a minimum of 50% marks.",
          "Final selection will be based on the GAT score, academic performance, and an interview.",
        ],
      },
      admissionProcess: {
        heading: "Admission Process",
        content:
          "The admission process for the MS Mathematics program involves an entrance test and an interview. The final selection is based on a weighted score of the test, academic performance, and the interview:",
        points: [
          "GAT (General) or STS Test: 50% of total weightage.",
          "Academic performance: 25% of total weightage.",
          "Interview with the admissions committee: 25% of total weightage.",
        ],
      },
      additionalRequirements: {
        heading: "Additional Requirements",
        content:
          "In addition to coursework, students must fulfill the following program requirements:",
        points: [
          "Thesis: A 6-credit research project, defended before an academic panel.",
          "Specializations: Options include Mathematical Finance, Abstract Algebra, Fluid Mechanics, and Computational Mathematics.",
          "Comprehensive Examination: Required for demonstrating mastery in the chosen specialization.",
          "Research Participation: Active involvement in seminars, workshops, and research activities.",
        ],
      },
    },
  },
  ms_computer_science: {
    title: "MS in Computer Science & MS in Software Engineering",
    department: "Department of Computer Science",
    schemaLink: "https://www.iba-suk.edu.pk", // Replace with actual link if available
    sections: {
      overview: {
        heading: "Program Overview",
        content:
          "The MS in Computer Science and MS in Software Engineering programs aim to prepare students for careers in academia, research, and industry. These programs focus on building advanced skills in specialized areas of computing, while providing a strong foundation in both theoretical and practical aspects of computer science and software engineering.",
        points: [
          "Specializations available in Database and Multimedia Systems, and Computer Networks.",
          "Develops expertise in both research and practical applications.",
          "Focus on preparing students for leadership roles in the IT industry and academia.",
          "Equips students with deep insights into computer science and emerging technologies.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The MS programs are structured to provide students with a mix of core courses, electives, and research or project work to deepen their knowledge in the field. Students have the option to pursue either a thesis or a project for degree completion.",
        points: [
          "Duration: Minimum 2 years (4 Semesters), Maximum 4 years.",
          "Credit Hours: 30 (including course work and thesis/project work).",
          "Core Courses: 18 Credit Hours.",
          "Elective Courses: 6 Credit Hours.",
          "Thesis or Project: 6 Credit Hours for thesis or 9 Credit Hours for project work.",
        ],
      },
      eligibilityCriteria: {
        heading: "Eligibility Criteria",
        content:
          "Admissions are merit-based, considering academic performance, test results, and interview performance.",
        points: [
          "BS/B.E. in Computer Science, Software Engineering, or related fields (min 130 credit hours) or a 16-year degree in Science and Engineering disciplines.",
          "Minimum CGPA of 2.2 or first division from an HEC-recognized institution.",
          "Candidates must clear the Sukkur IBA Graduate Admission Test (SIBAGAT) or equivalent GRE test.",
        ],
      },
      admissionProcess: {
        heading: "Admission Process",
        content:
          "The admission process involves a Sukkur IBA University Graduate Admission Test, followed by an interview. Shortlisted candidates are evaluated based on their test scores and interview performance.",
        points: [
          "Graduate Admission Test (SIBAGAT) with comprehensive evaluation (English, Mathematics, and Subject Knowledge).",
          "Shortlisted candidates are invited for an interview.",
          "Final selection is based on academic performance, test scores, and interview.",
        ],
      },
      additionalRequirements: {
        heading: "Additional Requirements",
        content:
          "Students must complete the following to meet the program requirements:",
        points: [
          "Thesis Option: Complete 24 credit hours of coursework and defend a 6-credit thesis.",
          "Project Option: Complete 27 credit hours of coursework and defend a 9-credit project.",
          "Specializations: Options include Database and Multimedia Systems, and Computer Networks.",
          "Completion of two non-credit SIBA Core courses.",
          "Passing the NTS (GAT) test with a minimum qualifying score.",
          "Maintaining a minimum Cumulative GPA of 2.2 on a 4.0 scale.",
        ],
      },
    },
  },
  me_electrical_engineering: {
    title: "ME in Electrical Engineering",
    department: "Department of Electrical Engineering",
    schemaLink: "https://www.iba-suk.edu.pk", // Replace with actual link if available

    sections: {
      overview: {
        heading: "Program Overview",
        content:
          "The objective of this program is to establish a meritorious platform and center of excellence in the diverse fields of electronics and communication. With highly qualified faculty and excellent on-campus facilities, this program is ideally suitable for mid-career professionals and fresh graduates looking to augment their technical competence with consolidated teaching/learning of advanced and emerging technologies and research.",
        points: [
          "Focus on advanced and emerging technologies in electrical engineering.",
          "Designed for both mid-career professionals and fresh graduates.",
          "Access to excellent on-campus facilities and highly qualified faculty.",
          "Emphasis on research and technical competence.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The ME program consists of a comprehensive curriculum designed to provide a holistic understanding of electrical engineering, blending theoretical concepts with practical applications.",
        points: [
          "Minimum Duration: 3 Years",
          "Maximum Duration: 5 Years",
          "Total Credit Hours: 54",
          "Thesis Component: 30 Credit Hours",
          "Course Work Component: 24 Credit Hours (with Thesis) or 30 Credit Hours (with Project)",
        ],
      },
      eligibilityCriteria: {
        heading: "Eligibility Criteria",
        content:
          "Candidates must fulfill the following requirements for admission to the ME program.",
        points: [
          "16 years of education in a relevant field with at least first division or 2.2 CGPA from an HEC recognized university/institution.",
          "Candidates should have cleared GAT-General with at least 50% marks or appear in SIBA Graduate Test-General.",
        ],
      },
      admissionProcess: {
        heading: "Admission Process",
        content:
          "The admission process is merit-based and includes various assessments.",
        points: [
          "Performance in the GAT (General)/SIBA Graduate Test (50%).",
          "Interview performance (25%).",
          "Research proposal (25%).",
        ],
      },
      additionalRequirements: {
        heading: "Additional Requirements",
        content:
          "Candidates must complete either Thesis work or Project work for their ME degree.",
        points: [
          "ME with Thesis Work: Complete 24 credit hours of course work, submit a thesis, and defend it.",
          "ME with Course Work: Complete 30 credit hours of course work, submit a project report, and defend it.",
          "Candidates must have cleared two non-credit courses offered as SIBA Core courses.",
          "Maintain a minimum Cumulative GPA of 2.2 (on a scale of 4).",
        ],
      },
    },
  },

  phd_computer_science: {
    title: "PhD in Computer Sciences",
    department: "Department of Computer Sciences",
    schemaLink: "https://www.iba-suk.edu.pk", // Replace with actual link if available

    sections: {
      overview: {
        heading: "Program Overview",
        content:
          "The general purpose of the PhD program is to provide an educational experience that will enable its graduates to develop new knowledge in the discipline. PhD candidates are fundamentally driven by their desire to advance the state of the art and to discover new phenomena, theories, and applications that were previously unknown. The Sukkur IBA University PhD Program emphasizes rigorous coursework and high-quality research that should be published in peer-reviewed international conferences and journals.",
        points: [
          "specialization Areas: Soft Computing,Databases and Information Systems,Computer Networks",
          "Focus on advancing the state of the art in computer sciences.",
          "Emphasis on rigorous coursework and high-quality research.",
          "Encouragement to tackle both coursework and research in parallel.",
          "Research topics include Soft Computing, Databases and Information Systems, and Computer Networks.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The PhD program is structured to provide a comprehensive understanding of computer sciences with a focus on research.",
        points: [
          "Duration: 3 Years",
          "Semesters: 6 Semesters",
          "Total Credit Hours: 48",
          "Course Work Component: 18 Credit Hours",
          "Thesis Component: 30 Credit Hours",
        ],
      },
      eligibilityCriteria: {
        heading: "Eligibility Criteria",
        content:
          "Candidates must fulfill the following requirements for admission to the PhD program.",
        points: [
          "MS (Computer Science, Software Engineering, Information Technology) 18 years degree.",
          "Minimum of 70% or CGPA 3.0 (out of 4.0 in the Semester System) or First Division (in the Annual System) from an HEC recognized university/institution.",
        ],
      },
      admissionProcess: {
        heading: "Admission Process",
        content:
          "The admission process is merit-based and includes various assessments.",
        points: [
          "Sukkur IBA University Graduate Admission Test (SIBAGAT).",
          "GRE (International) Subject Test with minimum 60% Percentile Score or GAT Subject Test with minimum 60% marks.",
          "Two references from the last attended institute/university.",
          "Brief proposal indicating research interests.",
          "Interview performance based on academic performance and admission test scores.",
          "1. GAT (General) NTS/STS Test: 50% weightage",
          "2. Academic Performance: 25% weightage",
          "3. Interview: 25% weightage",
        ],
      },
      additionalRequirements: {
        heading: "Additional Requirements",
        content:
          "Candidates must complete specific requirements for their PhD degree.",
        points: [
          "Pass the PhD Comprehensive Examination after completing coursework.",
          "Conduct research at Sukkur IBA University, with research accepted by HEC recognized journals before final dissertation defense.",
          "Present the draft of the PhD dissertation to the Doctoral Committee and defend it.",
          "The dissertation must be evaluated by overseas experts before final approval.",
        ],
      },
    },
  },
  phd_mathematics: {
    title: "PhD in Mathematics",
    department: "Department of Mathematics",
    schemaLink: "https://www.iba-suk.edu.pk", // Replace with actual link if available

    sections: {
      overview: {
        heading: "Program Overview",
        content:
          "The PhD program in Mathematics offers an extensive academic framework designed to equip students with advanced research skills. The program emphasizes the development of new mathematical theories and their applications across various fields.",
        points: [
          "Focus on mathematical research with real-world applications.",
          "Access to experienced faculty and advanced coursework.",
          "Encouragement for interdisciplinary projects.",
          "Opportunities for publication in reputable journals.",
          "Specialization areas include Pure Mathematics, Applied Mathematics, Mathematical Modeling, Statistics, and Computational Mathematics.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The PhD program comprises a total of 48 credit hours, with coursework and a thesis requirement. The minimum duration for completion is 3 years, with a maximum of 5 years.",
        points: [
          "Minimum Duration: 3 Years",
          "Maximum Duration: 5 Years",
          "Total Credit Hours: 48",
          "Course Work: 18 Credit Hours",
          "Thesis: 30 Credit Hours",
        ],
      },
      eligibilityCriteria: {
        heading: "Eligibility Criteria",
        content:
          "Candidates must meet the following criteria for admission to the PhD program.",
        points: [
          "18 years of education (MS in Mathematics or related fields) with a minimum of 70% or CGPA 3.0.",
          "Performance in GAT General/NTS or equivalent tests.",
          "Submission of a research proposal.",
        ],
      },
      admissionProcess: {
        heading: "Admission Process",
        content:
          "The admission process is merit-based, evaluating candidates on various assessments.",
        points: [
          "Admissions are based on merit, assessed through various criteria:",
          "1. GAT (General) NTS/STS Test: 50% weightage",
          "2. Academic Performance: 25% weightage",
          "3. Interview: 25% weightage",
        ],
      },
      additionalRequirements: {
        heading: "Additional Requirements",
        content:
          "Candidates must fulfill specific research and publication requirements.",
        points: [
          "Completion of a dissertation.",
          "Publication of at least one research article in an HEC recognized journal.",
        ],
      },
    },
  },

  phd_management_science: {
    title: "PhD in Management",
    department: "Department of Management",
    schemaLink: "https://www.iba-suk.edu.pk", // Replace with actual link if available

    sections: {
      overview: {
        heading: "Program Overview",
        content:
          "The PhD program in Management focuses on developing advanced knowledge and research skills. Graduates will contribute to knowledge creation and address societal issues through rigorous research.",
        points: [
          "Specialization Areas: Finance, Marketing, Human Resource Management (HRM)",
          "Focus on developing advanced knowledge in specialized management fields.",
          "Opportunities for interdisciplinary collaboration.",
          "Emphasis on ethical research practices.",
          "Encouragement for publication in reputable journals.",
        ],
      },
      programStructure: {
        heading: "Program Structure",
        content:
          "The PhD program requires completion of 48 credit hours over a minimum of 3 years and a maximum of 5 years.",
        points: [
          "Minimum Duration: 3 Years",
          "Maximum Duration: 5 Years",
          "Total Credit Hours: 48",
          "Elective Courses: 12 Credit Hours",
          "Thesis: 30 Credit Hours",
        ],
      },
      eligibilityCriteria: {
        heading: "Eligibility Criteria",
        content:
          "Candidates must fulfill the following requirements for admission to the PhD program.",
        points: [
          "18 years of education (MS/M.Phil/MBA) with a minimum of 70% or CGPA 3.0.",
          "Performance in GAT Subject test or equivalent.",
          "Submission of a research proposal.",
        ],
      },
      admissionProcess: {
        heading: "Admission Process",
        content:
          "The admission process is based on merit and evaluates various components.",
        points: [
          "Admissions are based on merit, assessed through various criteria:",
          "1. GAT (General) NTS/STS Test: 50% weightage",
          "2. Academic Performance: 25% weightage",
          "3. Interview: 25% weightage",
        ],
      },
      additionalRequirements: {
        heading: "Additional Requirements",
        content:
          "Candidates must fulfill specific requirements related to research and publications.",
        points: [
          "Publication of at least one research article in an HEC recognized journal.",
          "Completion of a mini-thesis or research publication.",
        ],
      },
    },
  },

  // Additional programs can be added here
};

export default programDetails;
